import { render, staticRenderFns } from "./LangCheck.vue?vue&type=template&id=4f69a274&scoped=true&"
import script from "./LangCheck.vue?vue&type=script&lang=js&"
export * from "./LangCheck.vue?vue&type=script&lang=js&"
import style0 from "./LangCheck.vue?vue&type=style&index=0&id=4f69a274&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f69a274",
  null
  
)

export default component.exports